export { default } from './SectionFactors';